<script>
    import {_, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig, bonuses} from "../../stores.js";

    let { item, gameItem, globals } = $props();
    let itemDetails = $state({});

    function getSpriteName() {
        if (
            gameItem.category == 'troopAttackBooster' ||
            gameItem.category == 'troopDefenseBooster'
        ) {
            if (gameItem.seconds == 7200) {
                return gameItem.category + '_special';
            }
        }

        return gameItem.category;
    }

    function getSpriteNameWithBonus() {
        if (!$bonuses) {
            return gameItem.category;
        }

        if (
            gameItem.category == 'troopAttackBooster' ||
            gameItem.category == 'troopDefenseBooster'
        ) {
            if (gameItem.seconds == 7200) {
                return $bonuses[gameItem.bonusType] + 'Booster_special';
            }
        }

        if (gameItem.category === 'trainCapacityBooster' || gameItem.category === 'trainingCapacityBooster' || gameItem.category === 'trainingCapacity') {
            return 'trainingCapacityBooster';
        }
        if (gameItem.category === 'lordXpBooster' || gameItem.category === 'lordXp' || gameItem.bonusType === 42) {
            return 'lordXpBooster';
        }
        if (gameItem.category === 'antiScoutBooster' || gameItem.category === 'antiscoutBooster' || gameItem.category === 'antiScout' || gameItem.bonusType === 29) {
            return 'antiscoutBooster';
        }

        return $bonuses[gameItem.bonusType] + 'Booster';
    }

    function setItemDetails() {
        if (gameItem.bonusType) {
            itemDetails.title = $_('ItemBooster' + gameItem.bonusType + 'ItemTitle', {
                values: {
                    TIME: globals?.formatTimeFriendly?.(gameItem.seconds),
                    PERCENT: gameItem.bonusValue,
                },
            });
            itemDetails.description = $_('ItemBooster' + gameItem.bonusType + 'ItemDescription', {
                values: {
                    TIME: globals?.formatTimeFriendly?.(gameItem.seconds),
                    PERCENT: gameItem.bonusValue,
                },
            });
            itemDetails.icon = getSpriteNameWithBonus();
        } else {
            itemDetails.title = $_(gameItem.category + 'ItemTitle', {
                values: {
                    TIME: globals?.formatTimeFriendly?.(gameItem.seconds),
                    PERCENT: gameItem.bonusValue,
                },
            });
            itemDetails.description = $_(gameItem.category + 'ItemDescription', {
                values: {
                    TIME: globals?.formatTimeFriendly?.(gameItem.seconds),
                    PERCENT: gameItem.bonusValue,
                },
            });
            itemDetails.icon = getSpriteName();
        }
        itemDetails.amount = item.amount;
        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
